import { gql } from '@apollo/client';
import { EEmployeeTalkStatus } from '@sharedInterfaces/IEmployeeTalk';
import EmployeeTalk, { EmployeeTalkGQL } from '@src/Objects/EmployeeTalk';
import { addEmployeeTalk } from '@store/reducer/employeeTalksReducer';
import store from '@store/store';

import GraphQL from '../graphQL';

const m = gql`
  mutation CreateEmployeeTalk(
    $title: String!
    $employeeId: Int!
    $meetingPartnerId: Int!
    $templateId: Int!
    $scheduledDate: String
    $status2: String!
  ) {
    createEmployeeTalk(
      title: $title
      employeeId: $employeeId
      meetingPartnerId: $meetingPartnerId
      templateId: $templateId
      scheduledDate: $scheduledDate
      status2: $status2
    ) ${EmployeeTalkGQL}
  }
`;

export default async function createEmployeeTalk(
    title: string,
    employeeId: number,
    meetingPartnerId: number,
    templateId: number,
    scheduledDate?: Date,
    status2: EEmployeeTalkStatus = EEmployeeTalkStatus.PLANNED,
): Promise<EmployeeTalk> {
    const variables = {
        title,
        employeeId,
        meetingPartnerId,
        templateId,
        scheduledDate: scheduledDate?.toISOString(),
        status2,
    };

    return GraphQL.mutate<any>(m, variables).then((data) => {
        const employeeTalk = new EmployeeTalk(data);
        store.dispatch(addEmployeeTalk(employeeTalk));
        return employeeTalk;
    });
}
